/* Édition Mantra — bloc de personnalisation fiche produit (Mission 5)
   Données famille/mantras/config : assets/oriive-mantras.json (source unique).
   Données produit (ancres, vinyle, zone, prix) : JSON inline du snippet. */
(function () {
  'use strict';

  var root = document.getElementById('oriive-mantra');
  if (!root || root.dataset.omInit) return;
  root.dataset.omInit = '1';

  var dataTag = root.querySelector('[data-om-data]');
  if (!dataTag) return;
  var D;
  try { D = JSON.parse(dataTag.textContent); } catch (e) { return; }

  var els = {
    toggle: root.querySelector('[data-om-toggle]'),
    body: root.querySelector('[data-om-body]'),
    universBtns: Array.prototype.slice.call(root.querySelectorAll('[data-om-famille]')),
    accroche: root.querySelector('[data-om-accroche]'),
    pastilles: root.querySelector('[data-om-pastilles]'),
    libre: root.querySelector('[data-om-libre]'),
    champ: root.querySelector('[data-om-libre-champ]'),
    compteur: root.querySelector('[data-om-compteur]'),
    erreur: root.querySelector('[data-om-erreur]'),
    apercuBloc: root.querySelector('[data-om-apercu-bloc]'),
    cadreHaut: root.querySelector('[data-om-apercu="haut"]'),
    cadreBas: root.querySelector('[data-om-apercu="bas"]'),
    stage: root.querySelector('[data-om-stage]'),
    stageTexte: root.querySelector('[data-om-stage-texte]'),
    stageLegende: root.querySelector('[data-om-stage-legende]'),
    stageVisuel: root.querySelector('[data-om-stage-visuel]'),
    stageImg: root.querySelector('[data-om-stage-img]'),
    stagePoseHaut: root.querySelector('[data-om-stage-pose="haut"]'),
    stagePoseBas: root.querySelector('[data-om-stage-pose="bas"]'),
    avertissement: root.querySelector('[data-om-avertissement]'),
    cbHaut: root.querySelector('[data-om-placement="haut"]'),
    cbBas: root.querySelector('[data-om-placement="bas"]'),
    props: {}
  };
  Array.prototype.forEach.call(root.querySelectorAll('[data-om-prop]'), function (i) {
    els.props[i.getAttribute('data-om-prop')] = i;
  });

  var form = root.closest('form');
  var atc = form ? form.querySelector('.pdp2-atc') : document.querySelector('#pdp-form .pdp2-atc');
  var atcTexteOrigine = atc ? atc.textContent.trim() : 'Ajouter au panier';

  /* Garde-fou de lisibilité : conversion px → mm.
     Hypothèse de cadrage : la largeur de l'image d'aperçu couvre ≈ 68 cm de
     scène réelle (cadrage serré sur le mannequin). Valeur calibrée pour qu'un
     texte libre de 12 caractères en script sur la ceinture déclenche l'alerte,
     sans toucher les mantras standards. La hauteur d'x de Sacramento est basse
     (≈ 0,4 em) : c'est elle qui fait foi pour la découpe du vinyle. */
  var SCENE_LARGEUR_MM = 680;
  var XHAUTEUR_SCRIPT = 0.4;

  var CFG = { max_caracteres: 12, prix_placement: 900, hauteur_lettre_min_mm: 8 };
  var FAMILLES = {};
  var state = {
    famille: 'esprit',
    mantra: null,      // texte brut de la pastille choisie
    libre: false,      // pastille « Mon texte » active
    texteLibre: '',
    haut: false,
    bas: false
  };

  function familleValide(f) { return !!FAMILLES[f]; }

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function nbPlacements() { return (state.haut ? 1 : 0) + (state.bas ? 1 : 0); }

  function texteChoisi() {
    if (state.libre) return state.texteLibre.trim();
    return state.mantra || '';
  }

  function texteAvecSuffixe() {
    var t = texteChoisi();
    if (!t) return '';
    var fam = FAMILLES[state.famille];
    return t + ((fam && fam.suffixe) || '');
  }

  /* ---------- étape 1 : univers ---------- */
  function rendUnivers() {
    els.universBtns.forEach(function (b) {
      b.classList.toggle('is-actif', b.getAttribute('data-om-famille') === state.famille);
    });
    var fam = FAMILLES[state.famille];
    if (els.accroche) els.accroche.textContent = (fam && fam.accroche) || '';
  }

  /* ---------- étape 2 : pastilles + texte libre ---------- */
  function classeTypo(fam) {
    return fam && fam.typo === 'grotesque' ? 'om-typo-grotesque' : 'om-typo-script';
  }

  function rendPastilles() {
    var fam = FAMILLES[state.famille];
    if (!fam || !els.pastilles) return;
    els.pastilles.innerHTML = '';
    fam.mantras.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'om-pastille ' + classeTypo(fam) + (state.mantra === m && !state.libre ? ' is-actif' : '');
      b.textContent = m + (fam.suffixe || '');
      b.addEventListener('click', function () {
        state.mantra = m;
        state.libre = false;
        cacherErreur();
        rendPastilles();
        rendTout();
      });
      els.pastilles.appendChild(b);
    });
    var libre = document.createElement('button');
    libre.type = 'button';
    libre.className = 'om-pastille om-pastille--libre ' + classeTypo(fam) + (state.libre ? ' is-actif' : '');
    libre.textContent = root.dataset.omLibelleLibre || 'Mon texte';
    libre.addEventListener('click', function () {
      state.libre = true;
      state.mantra = null;
      rendPastilles();
      rendTout();
      if (els.champ) els.champ.focus();
    });
    els.pastilles.appendChild(libre);

    if (els.libre) els.libre.hidden = !state.libre;
    if (els.champ) {
      // FORCE : majuscules à l'affichage uniquement, la valeur saisie reste telle quelle
      els.champ.style.textTransform = fam.typo === 'grotesque' ? 'uppercase' : 'none';
      els.champ.className = 'om-libre__champ ' + classeTypo(fam);
    }
  }

  /* Filtre à la frappe : lettres non accentuées, chiffres, espace, apostrophe.
     Accents et émojis retirés, casse conservée. */
  function filtreTexte(v) {
    return v.replace(/[^A-Za-z0-9' ]/g, '').slice(0, CFG.max_caracteres);
  }

  function surSaisie() {
    var avant = els.champ.value;
    var apres = filtreTexte(avant);
    if (avant !== apres) {
      var pos = els.champ.selectionStart - (avant.length - apres.length);
      els.champ.value = apres;
      if (pos >= 0) els.champ.setSelectionRange(pos, pos);
    }
    state.texteLibre = els.champ.value;
    if (els.compteur) els.compteur.textContent = state.texteLibre.length + '/' + CFG.max_caracteres;
    if (state.texteLibre.trim()) cacherErreur();
    rendTout();
  }

  function montrerErreur(msg) {
    if (!els.erreur) return;
    els.erreur.textContent = msg;
    els.erreur.hidden = false;
  }
  function cacherErreur() { if (els.erreur) els.erreur.hidden = true; }

  /* ---------- étape 3 : aperçu ---------- */
  /* Couleur du vinyle selon le coloris de la variante sélectionnée (Option A).
     Lit le <select name="id"> du thème → cherche la variante dans vinyleParVariante ;
     repli sur D.vinyle (produit mono-couleur ou sans mapping). */
  function vinyleCle() {
    var sel = document.getElementById('pdp-variant-select') || (form && form.querySelector('[name="id"]'));
    var id = sel && sel.value;
    if (id && D.vinyleParVariante && D.vinyleParVariante[id]) return D.vinyleParVariante[id];
    return D.vinyle;
  }
  function couleurVinyle() { return vinyleCle() === 'noir' ? '#0A0A0A' : '#F5F1EA'; }

  /* Image d'aperçu (à-plat) du coloris sélectionné ; repli sur D.apercuUrl */
  function apercuCourant() {
    var sel = document.getElementById('pdp-variant-select') || (form && form.querySelector('[name="id"]'));
    var id = sel && sel.value;
    if (id && D.apercuParVariante && D.apercuParVariante[id]) return D.apercuParVariante[id];
    return D.apercuUrl;
  }

  function rendCadre(cadre, ancre, actif) {
    if (!cadre) return null;
    var texte = texteAvecSuffixe();
    var visible = actif && ancre && texte && D.apercuUrl;
    cadre.hidden = !visible;
    if (!visible) return null;

    var img = cadre.querySelector('[data-om-apercu-img]');
    var span = cadre.querySelector('[data-om-apercu-texte]');
    if (img.getAttribute('src') !== D.apercuUrl) img.setAttribute('src', D.apercuUrl);

    var fam = FAMILLES[state.famille];
    span.className = 'om-apercu__texte ' + classeTypo(fam);
    span.textContent = fam.typo === 'grotesque' ? texte.toUpperCase() : texte;
    span.style.color = couleurVinyle();
    span.style.left = ancre.x + '%';
    span.style.top = ancre.y + '%';
    span.style.transform = 'translate(-50%, -50%) rotate(' + (ancre.rotation || 0) + 'deg)';

    // Ajustement : le texte remplit exactement la largeur de l'ancrage,
    // quelle que soit sa longueur (comme le fera le vinyle réel).
    var largeurImg = img.clientWidth;
    if (!largeurImg) return null;
    var cible = largeurImg * (ancre.largeur / 100);
    var mesure = document.createElement('span');
    mesure.className = span.className;
    mesure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font-size:100px;left:-9999px;top:0;';
    mesure.textContent = span.textContent;
    cadre.appendChild(mesure);
    var largeur100 = mesure.scrollWidth || 1;
    cadre.removeChild(mesure);
    var fontSize = 100 * cible / largeur100;
    span.style.fontSize = fontSize + 'px';

    // Hauteur de lettre estimée en mm réels (voir SCENE_LARGEUR_MM)
    var pxParMm = largeurImg / SCENE_LARGEUR_MM;
    var lettreMm = (fontSize * XHAUTEUR_SCRIPT) / pxParMm;
    return { typo: fam.typo, lettreMm: lettreMm };
  }

  /* Mode héros (maquette PDP Mantra) : aperçu typographique sur fond sombre,
     sans image produit. La lisibilité est estimée par la même géométrie que
     le bon d'atelier (scène 680 mm, avance moyenne par glyphe). */
  var MODE_HEROS = root.dataset.omMode === 'heros';

  function lettreMmEstimee(texte, ancre, typo) {
    if (!ancre || !ancre.largeur) return 99;
    var glyphes = Math.max(1, texte.length);
    var avance = typo === 'grotesque' ? 0.68 : 0.29;
    var facteur = typo === 'grotesque' ? 0.72 : XHAUTEUR_SCRIPT;
    var largeurVinyleMm = ancre.largeur / 100 * SCENE_LARGEUR_MM;
    return (largeurVinyleMm / (glyphes * avance)) * facteur;
  }

  function poserSurImage(span, ancre, texte, fam, visible) {
    if (!span) return;
    span.hidden = !visible || !ancre;
    if (span.hidden) return;
    span.className = 'om-stage__pose ' + classeTypo(fam);
    span.textContent = fam.typo === 'grotesque' ? texte.toUpperCase() : texte;
    span.style.color = couleurVinyle();
    span.style.left = ancre.x + '%';
    span.style.top = ancre.y + '%';
    span.style.transform = 'translate(-50%, -50%) rotate(' + (ancre.rotation || 0) + 'deg)';
    var largeurImg = els.stageImg.clientWidth;
    if (!largeurImg) return;
    var cible = largeurImg * (ancre.largeur / 100);
    var mesure = document.createElement('span');
    mesure.className = span.className;
    mesure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font-size:100px;left:-9999px;top:0;';
    mesure.textContent = span.textContent;
    els.stageVisuel.appendChild(mesure);
    var largeur100 = mesure.scrollWidth || 1;
    els.stageVisuel.removeChild(mesure);
    span.style.fontSize = (100 * cible / largeur100) + 'px';
  }

  function rendStage() {
    if (!els.stage) return;
    var texte = texteAvecSuffixe();
    var fam = FAMILLES[state.famille];
    els.stage.hidden = !texte;
    if (!texte || !fam) { if (els.avertissement) els.avertissement.hidden = true; return; }

    var urlApercu = apercuCourant();
    var modeImage = !!(urlApercu && (D.ancreHaut || D.ancreBas) && els.stageVisuel);
    els.stage.classList.toggle('om-stage--visuel-actif', modeImage);
    if (modeImage) {
      els.stageVisuel.hidden = false;
      els.stageTexte.hidden = true;
      if (els.stageImg.getAttribute('src') !== urlApercu) els.stageImg.setAttribute('src', urlApercu);
      var aucun = !state.haut && !state.bas;
      poserSurImage(els.stagePoseHaut, D.ancreHaut, texte, fam, state.haut || aucun);
      poserSurImage(els.stagePoseBas, D.ancreBas, texte, fam, state.bas || aucun);
      var base = els.stageLegende.dataset.base || 'APERÇU VINYLE MAT';
      var lHaut = els.stageLegende.dataset.haut || 'SUR LE HAUT';
      var lBas = els.stageLegende.dataset.bas || 'SUR LE BAS';
      var suff = '';
      if (state.haut && state.bas) suff = ' · HAUT + BAS';
      else if (state.haut) suff = ' · ' + lHaut;
      else if (state.bas) suff = ' · ' + lBas;
      els.stageLegende.textContent = base + suff;
      var alerteImg = false;
      if (fam.typo !== 'grotesque') {
        if ((state.haut || aucun) && lettreMmEstimee(texte, D.ancreHaut, fam.typo) < CFG.hauteur_lettre_min_mm) alerteImg = true;
        if (state.bas && lettreMmEstimee(texte, D.ancreBas, fam.typo) < CFG.hauteur_lettre_min_mm) alerteImg = true;
      }
      if (els.avertissement) els.avertissement.hidden = !alerteImg;
      return;
    }

    if (els.stageVisuel) els.stageVisuel.hidden = true;
    els.stageTexte.hidden = false;
    els.stageTexte.className = 'om-stage__mot ' + classeTypo(fam);
    els.stageTexte.textContent = fam.typo === 'grotesque' ? texte.toUpperCase() : texte;
    els.stage.classList.toggle('om-stage--clair', D.vinyle === 'noir');
    var base = els.stageLegende.dataset.base || 'APERÇU VINYLE MAT';
    var lHaut = els.stageLegende.dataset.haut || 'SUR LE HAUT';
    var lBas = els.stageLegende.dataset.bas || 'SUR LE BAS';
    var ou = '';
    if (state.haut && state.bas) ou = ' · HAUT + BAS';
    else if (state.haut) ou = ' · ' + lHaut;
    else if (state.bas) ou = ' · ' + lBas;
    els.stageLegende.textContent = base + ou;
    var alerte = false;
    if (fam.typo !== 'grotesque') {
      if (state.haut && lettreMmEstimee(texte, D.ancreHaut, fam.typo) < CFG.hauteur_lettre_min_mm) alerte = true;
      if (state.bas && lettreMmEstimee(texte, D.ancreBas, fam.typo) < CFG.hauteur_lettre_min_mm) alerte = true;
    }
    if (els.avertissement) els.avertissement.hidden = !alerte;
  }

  function rendApercu() {
    if (MODE_HEROS) { rendStage(); return; }
    if (!els.apercuBloc) return;
    var texte = texteChoisi();
    var actifGlobal = nbPlacements() > 0 && !!texte && !!D.apercuUrl;
    // métafield d'ancrage absent → aperçu masqué plutôt qu'un texte mal placé
    var possibleHaut = state.haut && !!D.ancreHaut;
    var possibleBas = state.bas && !!D.ancreBas;
    els.apercuBloc.hidden = !(actifGlobal && (possibleHaut || possibleBas));

    var infos = [];
    var a = rendCadre(els.cadreHaut, D.ancreHaut, actifGlobal && state.haut);
    var b = rendCadre(els.cadreBas, D.ancreBas, actifGlobal && state.bas);
    if (a) infos.push(a);
    if (b) infos.push(b);

    var alerte = infos.some(function (i) {
      return i.typo === 'script' && i.lettreMm < CFG.hauteur_lettre_min_mm;
    });
    if (els.avertissement) els.avertissement.hidden = !alerte;
  }

  /* ---------- étape 4 + prix ---------- */
  function rendPrix() {
    if (!atc) return;
    var nb = nbPlacements();
    if (nb > 0) {
      atc.textContent = 'Ajouter — ' + euros(D.prixProduit + CFG.prix_placement * nb);
    } else {
      atc.textContent = atcTexteOrigine;
    }
  }

  /* ---------- propriétés de ligne ---------- */
  function libellePlacement() {
    if (state.haut && state.bas) return 'Haut + Bas';
    if (state.haut) return 'Haut';
    if (state.bas) return 'Bas';
    return '';
  }

  function majProps(finaliser) {
    var nb = nbPlacements();
    var actif = nb > 0 && !!texteChoisi();
    Object.keys(els.props).forEach(function (k) { els.props[k].disabled = !actif; });
    if (!actif) return;
    var fam = FAMILLES[state.famille];
    els.props['Mantra'].value = texteAvecSuffixe();
    els.props['Placement'].value = libellePlacement();
    els.props['_perso_famille'].value = state.famille;
    els.props['_perso_typo'].value = fam ? fam.typo : '';
    els.props['_perso_zone_bas'].value = D.zoneBas || '';
    els.props['_perso_nb'].value = String(nb);
    if (finaliser || !els.props['_perso_key'].value) {
      els.props['_perso_key'].value = 'om-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }
  }

  /* ---------- rendu global ---------- */
  function rendTout() {
    rendUnivers();
    rendApercu();
    rendPrix();
    majProps(false);
  }

  /* ---------- événements ---------- */
  if (els.toggle) {
    els.toggle.addEventListener('click', function () {
      var deplie = root.dataset.etat === 'deplie';
      root.dataset.etat = deplie ? 'replie' : 'deplie';
      els.body.hidden = deplie;
      els.toggle.setAttribute('aria-expanded', String(!deplie));
    });
  }

  els.universBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.getAttribute('data-om-famille');
      if (!familleValide(f) || f === state.famille) return;
      state.famille = f;
      state.mantra = null; // les mantras changent d'univers
      cacherErreur();
      rendPastilles();
      rendTout();
    });
  });

  if (els.champ) els.champ.addEventListener('input', surSaisie);

  [els.cbHaut, els.cbBas].forEach(function (cb) {
    if (!cb) return;
    cb.addEventListener('change', function () {
      state.haut = !!(els.cbHaut && els.cbHaut.checked);
      state.bas = !!(els.cbBas && els.cbBas.checked);
      cacherErreur();
      rendTout();
    });
  });

  if (form) {
    /* Capture au niveau document : passe AVANT le handler AJAX du thème
       (enregistré sur le formulaire), pour bloquer ou remplacer l'ajout. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (nbPlacements() === 0) return; // perso annulée : ajout normal du thème
      if (state.libre && !state.texteLibre.trim()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        montrerErreur('Écris ton texte avant d’ajouter au panier.');
        if (els.champ) els.champ.focus();
        return;
      }
      if (!texteChoisi()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        montrerErreur('Choisis ton mantra avant d’ajouter au panier.');
        return;
      }
      majProps(true);
      if (window.OriiveMantraCart && window.OriiveMantraCart.pret) {
        // Mission 6 : un seul appel /cart/add.js avec les deux lignes
        e.preventDefault();
        e.stopImmediatePropagation();
        var fam = FAMILLES[state.famille];
        window.OriiveMantraCart.ajouterAvecPerso(form, {
          mantra: texteAvecSuffixe(),
          placement: libellePlacement(),
          famille: state.famille,
          typo: fam ? fam.typo : '',
          zoneBas: D.zoneBas || '',
          nb: nbPlacements(),
          key: els.props['_perso_key'].value
        });
      }
      // sans le module panier : le submit continue, la ligne principale
      // part seule avec ses propriétés (dégradé acceptable)
    }, true);
  }

  var minuteur;
  window.addEventListener('resize', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(rendApercu, 150);
  });

  /* Changement de coloris → recalcule la couleur du vinyle dans l'aperçu */
  var selVariante = document.getElementById('pdp-variant-select') || (form && form.querySelector('[name="id"]'));
  if (selVariante) selVariante.addEventListener('change', function () { rendApercu(); });

  /* ---------- init ---------- */
  fetch(D.mantrasUrl)
    .then(function (r) { return r.json(); })
    .then(function (json) {
      (json.familles || []).forEach(function (f) { FAMILLES[f.id] = f; });
      if (json.config) {
        CFG.max_caracteres = json.config.max_caracteres || CFG.max_caracteres;
        CFG.prix_placement = json.config.prix_placement || CFG.prix_placement;
        CFG.hauteur_lettre_min_mm = json.config.hauteur_lettre_min_mm || CFG.hauteur_lettre_min_mm;
      }
      if (els.champ) els.champ.maxLength = CFG.max_caracteres;
      state.famille = familleValide(D.familleActive) ? D.familleActive : 'esprit';
      rendPastilles();
      rendTout();
      var imgs = root.querySelectorAll('[data-om-apercu-img], [data-om-stage-img]');
      Array.prototype.forEach.call(imgs, function (img) {
        img.addEventListener('load', rendApercu);
      });
    })
    .catch(function () { /* sans données, le bloc reste inerte */ });
})();
